import React, { useState } from "react";
import { Modal, Container, Stack, Textarea, Button, Text, TextInput, Select, FileInput } from "@mantine/core";
import { supabaseClient } from "../supabase"; // Import your Supabase client

interface IGuestBookModalProps {
  opened: boolean;
  onClose: () => void;
}

export const GuestBookModal = ({ opened, onClose }: IGuestBookModalProps) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [crew, setCrew] = useState("");
  const [message, setMessage] = useState("");
  const [avatar, setAvatar] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);

  const crewOptions = [
    { value: "stroller", label: "Stroller Squad" },
    { value: "carseat", label: "Carseat Cuties" },
    { value: "diaper", label: "Diaper Division" },
    { value: "amazon", label: "Amazonians" },
  ];

  const handleSubmit = async () => {
    if (!firstName || !lastName || !crew) return alert("Please fill out all required fields!");
    setLoading(true);

    let imgUrl = null;

    try {
      // 1. Upload avatar to Supabase Storage if provided
      if (avatar) {
        const { data, error } = await supabaseClient.storage
          .from("guest_img")
          .upload(`avatars/${Date.now()}-${avatar.name}`, avatar);

        if (error) throw error;

        const { data: { publicUrl } } = supabaseClient.storage.from("guest_img").getPublicUrl(data.path);
        imgUrl = publicUrl;
      }

      // 2. Insert data into guest_book table
      const { error } = await supabaseClient.from("guest_book").insert([
        {
          name: `${firstName} ${lastName}`,
          crew: crew,
          message: message || null,
          img_url: imgUrl,
        },
      ]);

      if (error) throw error;

      alert("Thank you for signing the guest book!");
      onClose();
      // Reset form fields
      setFirstName("");
      setLastName("");
      setCrew("");
      setMessage("");
      setAvatar(null);
    } catch (error: any) {
      console.error("Error signing guest book:", error.message);
      alert("Something went wrong! Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={<Text size="xl" fw={700}>Sign the Guest Book!</Text>}
      size="md"
      withCloseButton
    >
      <Container>
        <Stack gap="md">
          <TextInput
            placeholder="First Name"
            label="First Name"
            required
            value={firstName}
            onChange={(e) => setFirstName(e.currentTarget.value)}
          />
          <TextInput
            placeholder="Last Name"
            label="Last Name"
            required
            value={lastName}
            onChange={(e) => setLastName(e.currentTarget.value)}
          />
          <Select
            label="Choose your crew"
            placeholder="Pick one"
            data={crewOptions}
            value={crew}
            onChange={(value) => setCrew(value || "")}
          />
          <Textarea
            placeholder="Leave your message here..."
            label="Message"
            value={message}
            onChange={(e) => setMessage(e.currentTarget.value)}
            radius="md"
            minRows={3}
          />
          <FileInput
            label="Upload an avatar (optional)"
            placeholder="Choose file"
            accept="image/*"
            value={avatar}
            onChange={setAvatar}
          />
          <Button onClick={handleSubmit} loading={loading} bg="#7fac9d" size="lg" fullWidth>
            Submit
          </Button>
        </Stack>
      </Container>
    </Modal>
  );
};
